import { Link } from "gatsby"
import React from "react"
import { ButtonLink, ResponsiveContentImage, ReviewWidget, SEO } from "shared/components"
import { MEDIUM_SCREEN_MEDIA_QUERY, SMALL_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"
import styled from "styled-components"
import { Divider, FormWithImage, IconCanada, Layout, Title1, Title2, Title3VariableTextSize, Wrapper } from "../components"
import { PageHero } from "../components/page_hero"
import badgeCanada from "../images/badges/badge-canada-150x150.png"
import badgeEco from "../images/badges/badge-eco-conscious-150x150.png"
import badgeTrial from "../images/badges/badge-trial-150x150.png"
import badgeWarranty from "../images/badges/badge-warranty-150x150.jpg"
import heroImage from "../images/big-bed-in-a-bedroom-P8ZDEST.jpg"
import logo from "../images/logo.png"
import mapleBg from "../images/maple-bg.jpg"
import mattress4 from "../images/mattress-4.jpg"
import ourTeam from "../images/mattress-5.jpg"
import womanWithPhone from "../images/smiling-woman-relaxing-with-phone-in-bed-P6Z83NV.jpg"
import { BLACK_COLOR, PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"


const LogoContainer = styled.div`
  margin-bottom: 20px;
  width: 200px;
`

const BlueMapleBg = styled.section`
  position: relative;
`

const BlueMapleBgTexture = styled.div`
  background-image: url( ${ mapleBg } );
  background-position: -20px -20px;
  background-size: 70px;
  bottom: 0;
  left: 0;
  opacity: 0.08;
  position: absolute;
  right: 0;
  top: 0;
`

const BlueMapleBgContent = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 4rem 0;
`

const ButtonContainer = styled.div`
  width: 300px;
  max-width: 100%;
  margin: 2rem 0;
`

const IconBanner = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  width: 100%;

  @media ${ SMALL_SCREEN_MEDIA_QUERY } {
    grid-row-gap: 4rem;
  }

  @media ${ MEDIUM_SCREEN_MEDIA_QUERY } {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
`

// tslint:disable-next-line: space-within-parens
const StyledReviewWidget = styled(ReviewWidget)`
  margin-top: 50px;
  height: 590px;

  @media ( min-width: 904px ) {
    height: 480px;
  }
`


const HomePage = () => (
  <Layout>
    <SEO title="Cuzy | Home" description="This is the homepage" />
    <PageHero
      backgroundImage={ heroImage }
      positionY="25%"
      // tslint:disable-next-line: jsx-no-lambda
      renderContent={ () => (
        <div className="flex flex-col items-center pt-20">
          <LogoContainer>
            <img src={ logo } />
            { /* <Img fluid={ data.logo.childImageSharp.fluid } /> */ }
          </LogoContainer>
          <Title1 className="text-center">Sleep Better With CUZY</Title1>
          <Title3VariableTextSize textSize="1.5rem" className="text-primary-100 font-bold text-center">CUZY will change the way you sleep, Let’s get you to your perfect CUZY mattress, get in touch with us & learn more about the right mattress.</Title3VariableTextSize>
          <ButtonContainer>
            <ButtonLink
              className="w-full rounded-full"
              color={ WHITE_COLOR }
              colorHover={ PRIMARY_COLOR_100 }
              textColor={ PRIMARY_COLOR_100 }
              textColorHover={ WHITE_COLOR }
              href="/about-us"
            >
              Read More
            </ButtonLink>
          </ButtonContainer>
        </div>
      ) }
    />
    <section>
      <Wrapper>
        <IconBanner>
          <div>
            <img src={ badgeCanada } alt="Made in Canada"/>
          </div>
          <div>
            <img src={ badgeEco } alt="Eco concious" />
          </div>
          <div>
            <img src={ badgeTrial } alt="Free shipping" />
          </div>
          <div>
            <img src={ badgeWarranty } alt="15 year warranty" />
          </div>
        </IconBanner>
      </Wrapper>
    </section>
    <BlueMapleBg className="bg-primary-100">
      <BlueMapleBgTexture />
      <Wrapper>
        <BlueMapleBgContent>
          <IconCanada className="mb-5"/>
          <Title2 className="max-w-2xl text-center text-white mb-5">Let's get you your perfect Sleep comfy mattress, get in touch with us &amp; learn more about the right mattress.</Title2>
          <Divider color={ WHITE_COLOR } className="mb-5" />
          <p className="text-white text-center mb-5">At CUZY our mission is to consistently deliver the most comfortable and enjoyable sleep experience. An overall experience that demonstrates outstanding value for our customers. We will provide superior service to our Canadian consumers and always strive to deliver the best sleep experience in terms of comfort, luxury & support.</p>
        </BlueMapleBgContent>
      </Wrapper>
    </BlueMapleBg>
    <div className="my-20 text-center">
      <Wrapper>
        <p className="mb-4">Cuzy was founded to help improve the health and well-being of Canadians, by ensuring that they get the best night's sleep possible. In today’s world, it’s become more important than ever to restore your body and mind with a full, uninterrupted sleep cycle. That’s why we’ve designed the best gel memory foam mattress in Canada, to provide the highest level of comfort and exceptional quality in order to help you achieve a restful sleep experience.</p>
        <p>With a Cuzy box mattress and base, you are guaranteed a comfortable and relaxing space to sleep. Our mattresses are designed to support your body while you sleep and enable you to wake up feeling both refreshed and invigorated.</p>
      </Wrapper>
    </div>
    <ResponsiveContentImage
      image={ mattress4 }
      containBackgroundImage={ false }
      themeColor={ PRIMARY_COLOR_100 }
      imageOn="left"
      // tslint:disable-next-line: jsx-no-lambda
      content={ () => (
        <div className="text-left py-10">
          <Title2 className="text-white mb-4">How Our Mattress is Made</Title2>
          <p className="text-white mb-4">Our medium-firm gel memory foam mattress is created by layering several different materials to provide you with the most flexible and comfortable surface. At the core, we use three inches of high resilience foam and then six inches of high-density foam for the ultimate pliability. Our mattresses also include an inch of memory gel, which is temperature-adjustable for the ultimate custom sleep experience.</p>
          <p className="text-white mb-4">Memory foam is a revolutionary substance, as it offers an open-cell design that maximizes airflow and allows the material to adapt and conform to anything on top. High-density memory foam reacts to body heat and molds to fit the user's frame, which makes it the ideal material for a high-quality mattress. At Cuzy, our cheap gel memory foam mattress also includes removable and washable quilting. That way, you can protect your investment and ensure that it remains in pristine condition throughout its lifetime.</p>
        </div>
      ) }
    />
    <ResponsiveContentImage
      image={ ourTeam }
      containBackgroundImage={ true }
      themeColor={ BLACK_COLOR }
      imageOn="right"
      // tslint:disable-next-line: jsx-no-lambda
      content={ () => (
        <div className="text-left py-10">
          <Title2 className="text-white mb-4">Foam Mattress Benefits</Title2>
          <p className="text-white mb-4">Ever since memory foam was first invented by NASA, foam mattresses have become one of the market's most innovative products, providing numerous benefits for users of all ages. If you suffer from joint problems or spinal discomfort that worsens after sleep, our memory foam mattress is a gentle and supportive solution that can reduce pressure on these sensitive areas. A traditional spring mattress pushes upwards and exerts force onto you as you sleep, which can exacerbate any underlying medical conditions or cause you to feel aches when you wake up and begin the day.</p>
          <p className="text-white mb-4">The unique design of a soft gel memory foam mattress also provides a host of other benefits, such as reducing the effect of movement on the other side of the bed -- which can be a source of conflict amongst couples. The open cell nature of foam also means that, unlike spring mattresses, there is less opportunity for allergenic matter to build up over time (such as dust and dust mites, mold and mildew). As a result, you're ensured a significantly more pleasant sleeping experience that is calm and undisturbed.</p>
        </div>
      ) }
    />
    <ResponsiveContentImage
      image={ womanWithPhone }
      containBackgroundImage={ false }
      themeColor={ PRIMARY_COLOR_100 }
      imageOn="left"
      // tslint:disable-next-line: jsx-no-lambda
      content={ () => (
        <div className="text-left">
          <a href="tel:19052261110"><Title2 className="text-white mb-4">Contact Us: 905-226-1110</Title2></a>
          <p className="text-white mb-4">If you are looking for the perfect mattress to buy, a gel memory foam mattress is the one for you. Please contact us today to learn more about the technology and how it can benefit your health and lifestyle.</p>
          <p className="text-white mb-4">You can view our soft gel memory foam mattress on the website or find our email and phone details in the <Link className="underline" to="/contact">Contact</Link> section. We can’t wait to hear from you!</p>
        </div>
      ) }
    />
    <section className="my-20 text-center">
      <Wrapper>
        <div className="flex flex-col items-center mb-16 w-full">
          <IconCanada className="mb-5" />
          <Divider color={ PRIMARY_COLOR_100 } className="mb-5" />
          <Title2 className="max-w-2xl text-center text-black">Imagine &amp; Create,</Title2>
          <Title2 className="max-w-2xl text-center text-black mb-5">We Make it So Simple!</Title2>
        </div>
        <iframe className="block w-full" src="https://www.juicer.io/api/feeds/cuzycanada/iframe" height="1000" />
      </Wrapper>
    </section>
    <div className="w-full">
      <StyledReviewWidget merchantId="5dc2efea8cf6da3d8516cf6b" />
    </div>
    <FormWithImage />
  </Layout>
)

export default HomePage
